import C5BaseDAO from "./C5BaseDAO";
import LojaModel from "../../model/LojaModel";

class C5LojaDAO extends C5BaseDAO {
  private static instance: C5LojaDAO;
  private endpoint = `${super.getBasePath()}/SalesChannel`;
  private allStoresCacheEndpoint = `${super.getAPIPath()}/api/ConsincoCache/stores`;

  private constructor() {
    super();
  }

  public static getInstance(): C5LojaDAO {
    if (!C5LojaDAO.instance) {
      C5LojaDAO.instance = new C5LojaDAO();
    }
    return C5LojaDAO.instance;
  }

  public async getAll(): Promise<LojaModel[]> {
    return this.get(
      "REQ_C5_LOJA_ALL",
      this.allStoresCacheEndpoint
    ).then((r: any) =>
      r.data.data.Stores.map((i: any) => LojaModel.toModel(i))
    );
  }
  public async getByZip(zipCode: string): Promise<LojaModel> {
    return await this.get(
      "REQ_LOJA_ZIPCODE",
      `${this.endpoint}?ZipCode=${zipCode}`
    ).then((r: any) => r.data.Channels[0] as LojaModel);
  }
}

export default C5LojaDAO;
